import React from 'react';
import { Modal, Form, Input, Select, Button, Typography, CreatableSelect } from '../../../../../../components';
import '../CreateAndManageModal.scss';

const { Option } = Select;
const { Title } = Typography;

export const CreateApplicationModal = ({ open, onCancel, onApply, moveGroups = [] }) => {
    const [form] = Form.useForm();
    const moveGroupId = Form.useWatch('moveGroupId', form);

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            onApply(values);
            form.resetFields();
        } catch (error) {}
    };

    const handleCancel = () => {
        form.resetFields();
        onCancel();
    };

    return (
        <Modal
            className="create-manage-modal"
            title={
                <Title level={4} className="modal-title">
                    Create Application
                </Title>
            }
            open={open}
            onCancel={handleCancel}
            footer={null}
            width={400}
            destroyOnHidden
        >
            <Form form={form} layout="vertical" initialValues={{ name: '', moveGroupId: undefined }}>
                <Form.Item
                    label={
                        <span>
                            Name <span className="required"></span>
                        </span>
                    }
                    name="name"
                    rules={[{ required: true, message: 'Unique name required' }]}
                >
                    <Input placeholder="Create Unique Application Name" />
                </Form.Item>
                <Form.Item label="Move Group" name="moveGroupId">
                    <CreatableSelect
                        selectPlaceholder="Add to Move Group"
                        addItemPlaceholder="Create New Move Group"
                        options={moveGroups}
                        value={moveGroupId}
                        onChange={(value) => form.setFieldsValue({ moveGroupId: value })}
                        placement="topLeft"
                    />
                </Form.Item>
                <div className="button-group">
                    <Button shape="round" onClick={handleCancel}>
                        Cancel
                    </Button>
                    <Button shape="round" type="primary" onClick={handleSubmit}>
                        Apply
                    </Button>
                </div>
            </Form>
        </Modal>
    );
};
